'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _utils = require('@iyunbao/utils');

var _zarm = require('zarm');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _tools = require('../utils/tools');

var _toast = require('../toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stopEventPropagation = function stopEventPropagation(e) {
  e.stopPropagation();
  // e.nativeEvent.stopImmediatePropagation();
};
var searchTimmer = null;
var labelAddon = ' > ';

var SearchPickerStack = function (_PureComponent) {
  _inherits(SearchPickerStack, _PureComponent);

  function SearchPickerStack(props) {
    _classCallCheck(this, SearchPickerStack);

    var _this = _possibleConstructorReturn(this, (SearchPickerStack.__proto__ || Object.getPrototypeOf(SearchPickerStack)).call(this, props));

    _initialiseProps.call(_this);

    _this.columns = {};
    _this.state = _extends({
      visible: props.visible || false,
      isShowSearchWapper: false,
      searchValue: '',
      searchResult: [],
      searchSource: [],
      isFocus: false,
      style: {},
      showResultText: false,
      keyNameValue: ''
    }, _this.resolveProps(props));

    _this.timer = null;
    return _this;
  }

  _createClass(SearchPickerStack, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.reposition();
      this.formatSearchSource();

      _utils.events.on(window, 'resize', this.onResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          dataSource = _props.dataSource,
          value = _props.value;

      if ('dataSource' in nextProps && Array.isArray(nextProps.dataSource) && !(0, _tools.deepAsset)(dataSource, nextProps.dataSource)) {
        this.setState(this.resolveProps(nextProps));
        this.formatSearchSource(nextProps);
        // 热门职业
      } else if ('value' in nextProps && !(0, _tools.deepAsset)(value, nextProps.value)) {
        this.setState(this.resolveProps(nextProps));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.reposition();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _utils.events.off(window, 'resize', this.onResize);
    }

    // 格式化数据成方便查询和渲染的格式


    // TODO 添加校验

  }, {
    key: 'renderGroup',
    value: function renderGroup(dataSource, value) {
      var _props2 = this.props,
          valueMember = _props2.valueMember,
          cols = _props2.cols;

      var group = [];
      var i = 0;
      while (dataSource) {
        var colVal = value[i];
        var childrenData = ((colVal ? this.obtainItem(dataSource, colVal[valueMember]) : dataSource[0]) || {}).children;

        if (childrenData && childrenData.length && i < cols - 1) {
          group.push(this.renderColumn(dataSource, i, colVal || _defineProperty({}, valueMember, '')));
          dataSource = childrenData;
        } else {
          group.push(this.renderColumn(dataSource, i, colVal || _defineProperty({}, valueMember, ''), true));
          dataSource = null;
        }

        i += 1;
      }

      return group;
    }
  }, {
    key: 'renderSearchWaper',
    value: function renderSearchWaper() {
      var _this2 = this;

      var prefixCls = this.props.prefixCls;
      var _state = this.state,
          searchResult = _state.searchResult,
          searchValue = _state.searchValue,
          showResultText = _state.showResultText;


      return _react2.default.createElement(
        'div',
        {
          className: prefixCls + '-search-wrapper'
        },
        _react2.default.createElement(
          'div',
          { className: prefixCls + '-search-wrapper-header' },
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-back-icon', onClick: function onClick() {
                return _this2.hideSearchWrapper();
              } },
            _react2.default.createElement(_icon2.default, { type: 'zuo' })
          ),
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-search-box', ref: function ref(e) {
                _this2.inputHeader = e;
              } },
            _react2.default.createElement(_icon2.default, { type: 'sousuo' }),
            _react2.default.createElement('input', {
              type: 'text',
              value: searchValue,
              ref: function ref(input) {
                _this2.textInput = input;
              },
              placeholder: '\u8BF7\u8F93\u5165',
              onChange: this.onSearchChange,
              onFocus: this.onFocus,
              onBlur: this.onBlur
            }),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_icon2.default, { type: 'guanbi_', style: { opacity: searchValue ? 1 : 0 }, className: 'clean-input', onClick: this.clearInput })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-search-btn', onClick: function onClick() {
                return _this2.search();
              } },
            '\u641C\u7D22'
          )
        ),
        showResultText ? _react2.default.createElement(
          'p',
          null,
          '\u5171\u641C\u7D22\u5230',
          searchResult.length,
          '\u6761\u7ED3\u679C'
        ) : '',
        _react2.default.createElement(
          'div',
          { className: prefixCls + '-search-wrapper-result' },
          searchResult.map(function (item, index) {
            return _this2.renderSearchItem(item, index);
          })
        )
      );
    }
  }, {
    key: 'renderWrapper',
    value: function renderWrapper() {
      var _this3 = this;

      var _props3 = this.props,
          title = _props3.title,
          dataSource = _props3.dataSource,
          prefixCls = _props3.prefixCls,
          itemRender = _props3.itemRender,
          submitType = _props3.submitType,
          submitText = _props3.submitText,
          beforeRender = _props3.beforeRender;
      var _state2 = this.state,
          visible = _state2.visible,
          errorMsg = _state2.errorMsg,
          value = _state2.value,
          isShowSearchWapper = _state2.isShowSearchWapper,
          isFocus = _state2.isFocus,
          style = _state2.style;

      var cls = (0, _classnames4.default)(prefixCls + '-bottom-wrapper', _defineProperty({}, prefixCls + '-show-search-wrapper', isShowSearchWapper));
      var wrapperStyle = isFocus && _utils.tools.isAndroid ? style : { height: '100%' };

      return _react2.default.createElement(
        _zarm.Popup,
        {
          visible: visible
          // onMaskClick={() => this.onMaskClick()}
          , className: 'cui-popup'
        },
        _react2.default.createElement(
          'div',
          {
            className: cls,
            style: wrapperStyle
          },
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-wrapper' },
            _react2.default.createElement(
              'div',
              { className: prefixCls + '-header' },
              _react2.default.createElement(
                'div',
                { className: prefixCls + '-cancel', onClick: function onClick() {
                    return _this3.onCancel();
                  } },
                '\u53D6\u6D88'
              ),
              _react2.default.createElement(
                'div',
                { className: prefixCls + '-title' },
                title
              ),
              _react2.default.createElement(
                'div',
                { className: prefixCls + '-submit-btn', onClick: function onClick() {
                    return _this3.onSubmit();
                  } },

                // 按钮类型为"search"时，给个默认的ReactNode，也可以自定义NodeDom或者text
                // eslint-disable-next-line multiline-ternary
                submitType === 'search' ? [_react2.default.createElement(_icon2.default, { type: 'sousuo', key: 'icon' }), _react2.default.createElement(
                  'span',
                  { key: 'text' },
                  submitText || '查询'
                )] : submitText
              )
            ),
            beforeRender,
            _react2.default.createElement(
              'div',
              { className: prefixCls + '-crumbs' },
              _react2.default.createElement(
                'p',
                null,
                '\u9009\u62E9\uFF1A',
                value.map(function (item) {
                  return itemRender(item);
                }).join(labelAddon)
              ),
              errorMsg ? _react2.default.createElement(
                'p',
                { className: prefixCls + '-crumbs-error' },
                errorMsg
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: prefixCls + '-stack-group' },
              this.renderGroup(dataSource, value)
            )
          ),
          this.renderSearchWaper()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          valueMember = _props4.valueMember,
          placeholder = _props4.placeholder,
          displayRender = _props4.displayRender;
      var displayValue = this.state.displayValue;

      var displayLabel = displayRender(displayValue);

      var labelCls = (0, _classnames4.default)(prefixCls + '-input', _defineProperty({}, prefixCls + '-placeholder', !displayLabel));

      return _react2.default.createElement(
        'div',
        { className: prefixCls },
        _react2.default.createElement(
          'div',
          { className: labelCls, onClick: function onClick() {
              return _this4.show();
            } },
          _react2.default.createElement('input', { type: 'hidden', value: displayValue.map(function (data) {
              return data[valueMember];
            }).join(',') }),
          displayLabel || placeholder
        ),
        this.renderWrapper()
      );
    }
  }]);

  return SearchPickerStack;
}(_react.PureComponent);

SearchPickerStack.defaultProps = {
  prefixCls: 'cui-picker',
  // eslint-disable-next-line
  value: [],
  valueMember: 'value',
  title: '请选择',
  submitType: 'button',
  submitText: '',
  beforeRender: '',
  placeholder: '请选择',
  // disabled: false,
  dataSource: [],
  cols: Infinity,
  displayItems: 8,
  itemHeight: 50,
  visible: false,
  displayRender: function displayRender(data) {
    return data.map(function (_ref3) {
      var label = _ref3.label;
      return label;
    }).join('');
  },
  itemRender: function itemRender(data) {
    return data.label;
  },
  itemTagRender: function itemTagRender(data, props) {
    return data.level < props.min || data.level > props.max ? _react2.default.createElement(
      'span',
      { className: 'stack-item-not-tag' },
      '\u4E0D\u53EF\u6295'
    ) : _react2.default.createElement(
      'span',
      { className: 'stack-item-tag' },
      '\u53EF\u6295'
    );
  },
  validate: function validate() {},
  onOk: function onOk() {},
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  onMaskClick: function onMaskClick() {}
};
SearchPickerStack.propTypes = {
  prefixCls: _propTypes2.default.string,
  // value: PropTypes.arrayOf(PropTypes.object),
  valueMember: _propTypes2.default.string,
  title: _propTypes2.default.string,
  submitText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  placeholder: _propTypes2.default.string,
  submitType: _propTypes2.default.string,
  beforeRender: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  // disabled: PropTypes.bool,
  dataSource: _propTypes2.default.arrayOf(_propTypes2.default.object),
  cols: _propTypes2.default.number,
  displayItems: _propTypes2.default.number,
  itemHeight: _propTypes2.default.number,
  visible: _propTypes2.default.bool,
  displayRender: _propTypes2.default.func,
  itemRender: _propTypes2.default.func,
  itemTagRender: _propTypes2.default.func,
  // eslint-disable-next-line
  validate: _propTypes2.default.func,
  onOk: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  onMaskClick: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onResize = function () {
    clearInterval(_this5.timer);
    _this5.timer = setTimeout(function () {
      var height = (window.innerHeight || document.documentElement.clientHeight) * 0.9;
      var style = { height: height };

      _this5.setState({ style: style });
    }, 300);
  };

  this.onFocus = function () {
    _this5.setState({ isFocus: true });
  };

  this.onBlur = function () {
    _this5.setState({ isFocus: false });
  };

  this.onMaskClick = function () {
    var onMaskClick = _this5.props.onMaskClick;

    _this5.close(true);
    if (typeof onMaskClick === 'function') {
      onMaskClick();
    }
  };

  this.onCancel = function () {
    var onCancel = _this5.props.onCancel;

    _this5.close(true);
    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  this.onSubmit = function () {
    var _props5 = _this5.props,
        onSubmit = _props5.onSubmit,
        submitType = _props5.submitType;
    // type为search直接显示搜索框不执行onSubmit行为

    if (submitType === 'search') {
      setTimeout(function () {
        if (_this5.textInput) {
          _this5.textInput.focus();
        }
      }, 400);
      _this5.showSearchWrapper();
    } else {
      onSubmit();
      _this5.close();
    }
  };

  this.onSearchChange = function (e) {
    _this5.setState({
      searchValue: e.target.value
    });
    clearInterval(searchTimmer);
    searchTimmer = setTimeout(function () {
      _this5.search();
    }, 1000);
  };

  this.showSearchWrapper = function () {
    _this5.setState({
      isShowSearchWapper: true,
      showResultText: false
    });
  };

  this.hideSearchWrapper = function () {
    _this5.setState({
      isShowSearchWapper: false,
      searchResult: [],
      searchValue: '',
      showResultText: false
    });
  };

  this.resolveProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props;
    var value = props.value,
        dataSource = props.dataSource,
        validate = props.validate;

    var resolveValue = [];
    value.reduce(function (list, item) {
      var valueItem = _this5.obtainItem(list, item);

      if (valueItem) {
        resolveValue.push(valueItem);

        return valueItem.children || [];
      }

      return [];
    }, dataSource);

    // 查询子级
    if (resolveValue.length < value.length) {
      resolveValue = [];
    }

    return {
      value: resolveValue,
      displayValue: [].concat(_toConsumableArray(resolveValue)),
      errorMsg: validate(value) || ''
    };
  };

  this.formatSearchSource = function () {
    var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props;
    var dataSource = nextProps.dataSource,
        submitType = nextProps.submitType;


    if (submitType !== 'search') {
      return false;
    }

    var searchSource = [];
    var traversing = function traversing(data, lever, positionArr, result) {
      data.forEach(function (item, index) {
        var nowPotionArr = [].concat(_toConsumableArray(positionArr));
        var nowResult = [].concat(_toConsumableArray(result));
        var nowItem = _extends({}, item);

        nowPotionArr[lever] = index;
        delete nowItem.children;
        nowResult[lever] = nowItem;

        if (item.children && item.children.length) {
          traversing(item.children, lever + 1, nowPotionArr, nowResult);
        } else {
          searchSource.push({
            // position: nowPotionArr,
            result: nowResult,
            label: item.label
          });
        }
      });
    };

    traversing(dataSource, 0, [], []);

    _this5.setState({
      searchSource: searchSource
    });
  };

  this.obtainItem = function (list, value) {
    var valueMember = _this5.props.valueMember;

    return list.filter(function (item) {
      return item[valueMember] === value;
    })[0];
  };

  this.change = function (index, cVal, isLast) {
    var _props6 = _this5.props,
        onOk = _props6.onOk,
        validate = _props6.validate;
    var value = _this5.state.value;

    var errorMsg = '';

    value = value.slice(0, index);

    if (cVal) {
      value[index] = cVal;

      // 先点未子级，再点有子级问题
      if (cVal.children && Array.isArray(cVal.children) && cVal.children.length) {
        isLast = false;
      }
    }
    errorMsg = validate(value);

    if (isLast && !errorMsg) {
      _this5.setState({
        value: value,
        displayValue: [].concat(_toConsumableArray(value)),
        errorMsg: errorMsg
      });
      _this5.close();

      onOk(value);
    } else {
      _this5.setState({ value: value, errorMsg: errorMsg });
    }
  };

  this.search = function () {
    // const { dataSource } = this.props;
    var _state3 = _this5.state,
        searchSource = _state3.searchSource,
        searchValue = _state3.searchValue;

    if (searchValue) {
      var searchResult = [];
      searchResult = searchSource.filter(function (item) {
        return item.label.indexOf(searchValue) !== -1;
      });
      if (!searchResult.length) {
        searchResult = [];
      }
      // Toast.show(`查到${searchResult.length}个结果`, 1000);
      _this5.setState({
        keyNameValue: searchValue,
        searchResult: searchResult,
        showResultText: true
      });
    }
  };

  this.clearInput = function () {
    _this5.setState({
      // searchResult: [],
      searchValue: ''
      // showResultText: false,
    });
  };

  this.searchOk = function (value) {
    var _props7 = _this5.props,
        onOk = _props7.onOk,
        validate = _props7.validate;

    var errorMsg = validate(value);

    if (!errorMsg) {
      _this5.setState({
        value: value,
        displayValue: [].concat(_toConsumableArray(value))
      });

      _this5.hideSearchWrapper();
      _this5.close();

      onOk(value);
    } else {
      _toast2.default.warning(errorMsg);
    }
  };

  this.show = function () {
    var disabled = _this5.state.disabled;

    if (!disabled) {
      _this5.setState({ visible: true });
    }
  };

  this.close = function () {
    var isCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var displayValue = _this5.state.displayValue;


    _this5.setState({ visible: false, isShowSearchWapper: false });
    _this5.hideSearchWrapper();
    if (isCancel) {
      _this5.setState({
        value: [].concat(_toConsumableArray(displayValue))
      });
    }
  };

  this.reposition = function () {
    var _props8 = _this5.props,
        dataSource = _props8.dataSource,
        valueMember = _props8.valueMember,
        cols = _props8.cols,
        displayItems = _props8.displayItems,
        itemHeight = _props8.itemHeight;
    var _state4 = _this5.state,
        visible = _state4.visible,
        value = _state4.value;


    if (!visible) {
      return false;
    }

    value.reduce(function (data, item, index) {
      var subValue = item[valueMember];
      var valIndex = data.map(function (dataItem) {
        return dataItem[valueMember];
      }).indexOf(subValue);

      if (index < cols && valIndex !== -1) {
        var target = _this5.columns['column' + index];
        var position = target.scrollTop;
        var viewTopIndex = valIndex - displayItems;

        if (position < (viewTopIndex + 1) * itemHeight || position > valIndex * itemHeight) {
          target.scrollTop = valIndex * itemHeight;
        }

        return data[valIndex].children || [];
      }

      return [];
    }, dataSource);
  };

  this.renderColumnItem = function (list, colIndex, data, isLast) {
    var _props9 = _this5.props,
        valueMember = _props9.valueMember,
        prefixCls = _props9.prefixCls,
        itemRender = _props9.itemRender,
        itemTagRender = _props9.itemTagRender,
        max = _props9.max;

    var pickVal = data[valueMember];

    var isLevel = false;

    return list.map(function (item, index) {
      isLevel = item.level && max;

      return _react2.default.createElement(
        'div',
        {
          key: +index,
          className: (0, _classnames4.default)(prefixCls + '-stack-item', {
            active: item[valueMember] === pickVal,
            level: isLevel
          }),
          onClick: function onClick() {
            return _this5.change(colIndex, item, isLast);
          }
        },
        itemRender(item),
        isLevel ? itemTagRender(item, _this5.props) : null,
        isLevel ? _react2.default.createElement(
          'span',
          { className: prefixCls + '-stack-level' },
          String(item.level) === '-1' ? '拒保' : item.level,
          '\u7C7B'
        ) : null
      );
    });
  };

  this.renderColumn = function () {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var colIndex = arguments[1];
    var data = arguments[2];
    var isLast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var _props10 = _this5.props,
        _props10$valueMember = _props10.valueMember,
        valueMember = _props10$valueMember === undefined ? SearchPickerStack.defaultProps.valueMember : _props10$valueMember,
        prefixCls = _props10.prefixCls;

    var pickVal = data[valueMember];
    var cls = (0, _classnames4.default)(prefixCls + '-stack-column', {
      'lower-hidden': !pickVal
    });

    return _react2.default.createElement(
      'div',
      {
        key: colIndex,
        className: cls,
        onClick: function onClick() {
          return _this5.change(colIndex - 1);
        }
      },
      _react2.default.createElement(
        'div',
        {
          className: prefixCls + '-stack-column-wrapper',
          ref: function ref(_ref4) {
            _this5.columns['column' + colIndex] = _ref4;
          },
          onClick: stopEventPropagation
        },
        _this5.renderColumnItem(list, colIndex, data, isLast)
      )
    );
  };

  this.renderSearchItem = function (data, idx) {
    var prefixCls = _this5.props.prefixCls;
    var keyNameValue = _this5.state.keyNameValue;


    var textData = data.result.map(function (item, index) {
      if (index < data.result.length - 1) {
        return item.label;
      }
      return data.label.replace(keyNameValue, '<span class="key-name">' + keyNameValue + '</span>');
    });

    return _react2.default.createElement(
      'div',
      { className: prefixCls + '-search-result-item', key: data.label + idx, onClick: function onClick() {
          return _this5.searchOk(data.result);
        } },
      textData.map(function (item, index) {
        return _react2.default.createElement('span', {
          key: index,
          dangerouslySetInnerHTML: { __html: '' + item + (index < textData.length - 1 ? '>' : '') }
        });
      })
    );
  };
};

exports.default = SearchPickerStack;